import { getBoundingClientRect } from './coordinates';
import { getDpr } from './device';

export const setupCanvas = (canvas) => {
  const dpr = getDpr();
  const rect = getBoundingClientRect(canvas);
  canvas.width = rect.width * dpr;
  canvas.height = rect.height * dpr;
  const ctx = canvas.getContext('2d');
  ctx.scale(dpr, dpr);
  return ctx;
};

interface Params {
  ctx: CanvasRenderingContext2D;
  text: string;
  x: number;
  y: number;
  fontSize?: number;
  color?: string;
  weight?: string;
}

export const renderText = ({
  ctx,
  text,
  x,
  y,
  fontSize = 12,
  color = 'white',
  weight = 'normal',
}: Params) => {
  ctx.beginPath();
  ctx.font = `${weight} ${fontSize}px PT Sans, sans-serif`;
  ctx.fillStyle = color;
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';
  ctx.fillText(text, x, y);
  ctx.fill();
};

export const drawTickIcon = ({ ctx, x, y, color }) => {
  ctx.beginPath();
  ctx.moveTo(x - 5, y);
  ctx.lineTo(x - 1, y + 4);
  ctx.lineTo(x + 5, y - 4);
  ctx.lineWidth = 2;
  ctx.strokeStyle = color;
  ctx.stroke();
};

export const drawTimesIcon = ({ ctx, x, y, color }) => {
  ctx.beginPath();
  ctx.moveTo(x - 4, y - 4);
  ctx.lineTo(x + 4, y + 4);
  ctx.moveTo(x + 4, y - 4);
  ctx.lineTo(x - 4, y + 4);
  ctx.lineWidth = 2;
  ctx.strokeStyle = color;
  ctx.stroke();
};

export const isCanvasSupported = () => {
  const canvas = document.createElement('canvas');
  return !!(canvas.getContext && canvas.getContext('2d'));
};

export const createCanvas = (id: string): HTMLCanvasElement => {
  const canvas = document.createElement('canvas');
  canvas.id = id;

  return canvas;
};
